module.exports = __webpack_public_path__ + "img/en.ori.3b46b54b.png";